import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxTooltipComponent } from './rx-tooltip.component';

@NgModule({
  imports: [CommonModule, RxTooltipComponent],
  exports: [RxTooltipComponent],
})
export class RxTooltipModule {}
